// extracted by mini-css-extract-plugin
export default {"container":"JobFields_container__AX4Ph","label":"JobFields_label__3pUcq","formFooter":"JobFields_formFooter__BQ7Yx"};